<div class="main-container">
  <h2 mat-dialog-title>{{ 'ENROLLMENT_COMPLETION.POPUP_TITLE' | translate }}</h2>
  <mat-dialog-content class="mat-typography">
    <p class="subtitle">
      {{ 'ENROLLMENT_COMPLETION.POPUP_SUBTITLE' | translate }}
    </p>
    <div>
      <rezolve-signature required
                         [height]="200"
                         [width]="400"
                         (isSignatureEmpty)="handleIsEmptySignature($event)"
                         (onSave)="handleOnSaveSignature($event)">
      </rezolve-signature>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="12px">
    <rezolve-secondary-button mat-dialog-close class="cancel-button" classList="medium">
      {{ 'CANCEL' | translate }}
    </rezolve-secondary-button>
    <rezolve-primary-button [disabled]="!isSigned" classList="medium" (handleClick)="onSubmit()">
      {{ 'ENROLLMENT_COMPLETION.COMPLETE_ENROLLMENT' | translate }}
    </rezolve-primary-button>
  </mat-dialog-actions>
  <div class="spinner-container" *ngIf="showSpinner"><mat-spinner></mat-spinner></div>
</div>
